import IconDownload from '@zendeskgarden/svg-icons/src/16/download-stroke.svg?react';
import * as Css from "../../spreadsheet/style";
import { DownloadReportProps } from './downloadReportType';

export function DownloadReport({ onDownload }: DownloadReportProps) {

    return (
        <Css.ButtonDownload onClick={onDownload}>
            <IconDownload />
            <span>
                Baixar relatório
            </span>
        </Css.ButtonDownload>
    );
}